/** Recipients (`recipients.to` of an outbound message) as text. @param {{ to?: string[] } | null | undefined} recipients */
export function recipientText(recipients) {
  const to = recipients?.to ?? [];
  return to.length ? to.join(', ') : '–';
}
